export default __webpack_public_path__ + "static/media/templo.964a0c7e.jpg";